import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import firebase from '@/firebase'

import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import PasswordReset from '@/views/PasswordReset.vue'
import PostThread from '@/views/PostThread.vue'
import Profile from '@/views/Profile.vue'
import Register from '@/views/Register.vue'
import ThreadDetail from '@/views/ThreadDetail.vue'
import NotFound from '@/views/NotFound.vue'
import Feedback from '@/views/Feedback.vue'
import UserDetail from '@/views/UserDetail.vue'
import Privacy from '@/views/Privacy.vue'
import Author from '@/views/Author.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false, },
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: Feedback,
    meta: { requiresAuth: false, },
  },
  {
    path: '/author/:id',
    name: 'Author',
    component: Author,
    meta: { requiresAuth: false, },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: { requiresAuth: false, },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresNoAuth: '/', },
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: PasswordReset,
    meta: { requiresAuth: false, },
  },
  {
    path: '/post-thread',
    name: 'PostThread',
    component: PostThread,
    meta: { requiresAuth: true, },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true, },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { requiresNoAuth: '/', },
  },
  {
    path: '/thread/:id',
    name: 'ThreadDetail',
    component: ThreadDetail,
    meta: { requiresAuth: false, },
  },
  {
    path: '/user/:id',
    name: 'UserDetail',
    component: UserDetail,
    meta: { requiresAuth: false, },
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin)
  const requiresNoAuth = to.matched.some(x => x.meta.requiresNoAuth)

  const fromName = from.name != null ? `from-${from.name}` : 'from-Outside';
  const toName = `to-${to.name}`

  await firebase.waitFirstAuth()

  if(requiresNoAuth && firebase.auth.currentUser != null){
    next(requiresNoAuth)
    return
  }

  if(requiresAdmin){
    try{
      const snapshot = await firebase.firestore.collection("users").doc(store.state.auth.user.uid)
        .get()
      if(snapshot.data().role !== 'admin') {
        next("/login")
        firebase.analytics.logEvent(`router-${fromName}-to-redirected-login`)
        return
      }
    } catch(e) {
      console.error(e)
      next("/login")
      firebase.analytics.logEvent(`router-${fromName}-to-redirected-login`)
      return
    }
  }

  if(requiresAuth && firebase.auth.currentUser == null){
    next('/login')
    firebase.analytics.logEvent(`router-${fromName}-to-redirected-login`)
    return
  }

  firebase.analytics.logEvent(`router-${fromName}-${toName}`)
  next()
})

export default router